import { userConstants } from '../_constants';
import { userService } from '../_services';
import { history } from '../_helpers';
import { loginEffect } from '../_effects';

export const loginPageActions = {
  login,
  aboutUs,
  resetData,
};

function resetData() {
  return (dispatch) => {
    dispatch(resetAuthData());
  };

  function resetAuthData() {
    return { type: userConstants.RESET_AUTHENTICATION, user: null };
  }
}

function login(user) {
  return (dispatch) => {
    dispatch(request(user));
    loginEffect.loginSet(user).then(
      (user) => {
        dispatch(success(user));
        if (user.data.statusCode == '200') {
          localStorage.setItem('userProfile', JSON.stringify(user?.data?.response[0]));
          localStorage.setItem('SessionId', JSON.stringify(user?.data?.sessionID));
          history.push('/home');
        } else {
          history.push('/');
        }
      },
      (error) => {
        console.log('action error', error);
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(user) {
    return { type: userConstants.LOGIN_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.LOGIN_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.LOGIN_FAILURE, error };
  }
}

function aboutUs(aboutUs) {
  return (dispatch) => {
    dispatch(request(aboutUs));
    loginEffect.getAboutUs(aboutUs).then(
      (aboutUs) => {
        dispatch(success(aboutUs));
      },
      (error) => {
        console.log('action error', error);
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(aboutUs) {
    return { type: userConstants.ABOUTUS_REQUEST, aboutUs };
  }
  function success(aboutUs) {
    return { type: userConstants.ABOUTUS_SUCCESS, aboutUs };
  }
  function failure(error) {
    return { type: userConstants.ABOUTUS_FAILURE, error };
  }
}
